module.exports = __webpack_public_path__ + "img/antes_despues_237.fc5e5775.png";